import { graphql } from '../../graphql';

export const getCombinedHomePageData = graphql(`
  query CombinedStaticPageData {
    ...FooterDataFields

    categories {
      ...CategoryFields
    }

    keywords(filter: { path: "/" }) {
      ...KeywordFields
    }
  }
`);
